export default "__VITE_ASSET__Bvg9ihXq__"